import * as React from 'react';
import styled from 'styled-components';
import { SidebarHeader } from './SidebarHeader';
import { colors } from '@ardoq/design-tokens';
import { text2 } from '@ardoq/typography';
import { DECORATOR_SELECTOR } from '@ardoq/decorators';

export const SIDEBAR_WIDTH = '320px';

const SidebarBody = styled.div`
  overflow-y: auto;
  overflow-x: hidden;
  transition-duration: 150ms;
  transition-property: overflow;
  transition-delay: 150ms;
  background-color: ${colors.surfaceDefaultSubtle};
  display: flex;
  flex-direction: column;
  flex-grow: 1;
`;

const Container = styled.div<{ $width: string }>`
  ${text2};
  overflow: hidden;
  width: ${props => props.$width};
  height: 100%;
  display: flex;
  flex-direction: column;
  ${DECORATOR_SELECTOR} {
    max-width: 100%;
  }
`;

const isSidebarHeader = (comp: React.ReactNode) =>
  React.isValidElement(comp) && comp.type === SidebarHeader;

type SidebarProps = {
  children: React.ReactNode;
  width?: string;
};

export const Sidebar = ({ children, width = SIDEBAR_WIDTH }: SidebarProps) => {
  const headerChildren = React.Children.toArray(children).filter(child =>
    isSidebarHeader(child)
  );

  const bodyChildren = React.Children.toArray(children).filter(
    child => !isSidebarHeader(child)
  );

  return (
    <Container data-testid="sidebar-content-wrapper" $width={width}>
      {headerChildren}
      <SidebarBody>{bodyChildren}</SidebarBody>
    </Container>
  );
};
